import React from 'react'

import Button from './Button';

export default function DigitalArtCard(props) {
  return (
    <div className='w-full h-full flex flex-col justify-start items-start'>
        <div className='text-blue keplersemi justify-start items-center flex w-full space-x-[0.5rem]'>
          <div className='ml-[0.5rem]'>MISC.</div>
          <div className='h-[1px] w-full bg-blue'/>
        </div>
        <div className='flex flex-wrap h-full w-full border-b-[1px] border-blue space-y-[-0.5rem] pb-[0.25rem]'>
          <div className='-mt-[0.5rem]'>
            <Button ReducedMotion = {props.ReducedMotion} setHover={props.setHover} link='https://open.spotify.com/user/312u746f7mja2md324mhznddi4ne?trackId=13SKWUEst7c0WohbwPAJJT'><p className='keplermed'>Spotify</p></Button>
          </div>
          <Button ReducedMotion = {props.ReducedMotion} setHover={props.setHover} link='https://www.youtube.com/watch?v=9OVNG7JpnJA&list=WL&index=122'><p className='keplermed'>Greatest Video Of All Time</p></Button>
        </div>
    </div>
  )
}
